import { network } from './network';

export async function queryTopRoles(opts) {
	const res = await network({
		url: '/ai/api/v1/category/main_public',
		method: 'get',
		params: {
			...opts
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryTabRoles(opts) {
	const res = await network({
		url: '/ai/api/v1/category/character_public',
		method: 'get',
		params: {
			...opts
		},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function deleteRole(opts) {
	const res = await network({
		url: '/ai/api/v1/role/delete',
		method: 'post',
		params: {
			id: opts.id,
		},
		headers: {
			token: opts.token || ''
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryRoleInfo(opts) {
	const res = await network({
		url: '/ai/api/v1/role/deep_info',
		method: 'get',
		params: {
			id: opts.id,
		},
		headers: {
			token: opts.token || ''
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryTags(opts) {
	const res = await network({
		url: '/ai/api/v1/tag/list',
		method: 'get',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function createRole(opts) {
	const res = await network({
		url: '/ai/api/v1/role/create',
		method: 'post',
		params: {
			avatar: {
				url: opts.avatar_url,
				width: opts.avatar_width,
				height: opts.avatar_height,
				size: opts.avatar_size
			},
			name: opts.name,
			description: opts.description,
			gender: opts.gender,
			tags: opts.tags,
			base_information: opts.baseInformation,
			first_message: opts.firstMessage,
			galleries: opts.galleries,
			is_edit: opts.is_edit,
			character_id: opts.character_id
		},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryRoleDetail(opts) {
	const res = await network({
		url: '/ai/api/v1/role/info_public',
		method: 'get',
		params: {
			...opts
		},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryRoleCards(opts) {
	const res = await network({
		url: '/ai/api/v1/card/all_public',
		method: 'get',
		params: {
			...opts
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}

